import React, { useState, useCallback, useEffect } from 'react';
import { useTheme } from 'styled-components';

import notificationIcon from 'assets/svg/notificationIcon.svg';

import { getCookie } from 'utils/cookies';

import { useNotification } from 'hooks/Notification';
import { useGlobalLoading } from 'hooks/LoadingContext';

import Icon from '../Icon';

import { handleDownloadFile } from './Utils';

import StyledTooltip from './components/CustomTooltip';
import NotificationMenu from './components/NotificationMenu';

import { NotificationContainer } from './styles';

import { getNotificatinAPI, updateNotificatinAPI } from './api';

import { IParamsUpdate } from './types';

const Notification: React.FC = () => {
  const { title } = useTheme();

  const { notifications } = useNotification();
  const { setGlobalLoading } = useGlobalLoading();

  const userId = Number(getCookie('@pdamodules::id'));
  const clientId = Number(getCookie('@pdamodules::codigoCliente'));

  const [isUpdate, setIsUpdate] = useState<boolean>(false);
  const [isMenuOpen, setIsMenuOpen] = useState<boolean>(false);
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  const hasNotifications: boolean = notifications.length > 0;

  const handleUpdateNotification = async () => {
    try {
      setGlobalLoading(true);

      await handleDownloadFile();

      const params: IParamsUpdate = {
        codigoCliente: clientId,
        codigoUsuario: userId,
      };

      await updateNotificatinAPI(params).then(res => {
        const notication: boolean = res.data?.visualizaAtualizacao || false;
        setIsUpdate(notication);
      });
    } catch (error) {
      setIsUpdate(false);
    } finally {
      setGlobalLoading(false);
    }
  };

  const getNotification = useCallback(async () => {
    try {
      await getNotificatinAPI(+clientId, +userId).then(res => {
        const notication: boolean = res.data?.visualizaAtualizacao || false;
        setIsUpdate(notication);
      });
    } catch (error) {
      setIsUpdate(false);
    }
  }, [clientId, userId]);

  useEffect(() => {
    getNotification();
  }, [getNotification]);

  return (
    <>
      <StyledTooltip
        title="Atualização disponível! Clique aqui para baixar o manual com as novidades."
        themeMode={title}
        disabled={hasNotifications}
      >
        <NotificationContainer
          type="button"
          onClick={e => {
            if (hasNotifications) {
              setIsMenuOpen(hasNotifications);
              setAnchorEl(e.currentTarget);
            } else {
              // handleDownloadFile();
              handleUpdateNotification();
            }
          }}
        >
          <Icon
            icon={notificationIcon}
            color={title === 'light' ? '#6C7293' : '#FFFFFF'}
          />
          {!hasNotifications && isUpdate && (
            <div className="round-display">!</div>
          )}

          {hasNotifications && (
            <div className="round-display">{notifications.length}</div>
          )}
          <NotificationMenu
            anchor={anchorEl}
            handleClose={() => setIsMenuOpen(false)}
            isOpen={isMenuOpen && hasNotifications}
            notifications={notifications}
          />
        </NotificationContainer>
      </StyledTooltip>
    </>
  );
};

export default Notification;
